import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=37892b88&scoped=true"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateModal.vue?vue&type=style&index=0&id=37892b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37892b88",
  null
  
)

export default component.exports